module.exports = __webpack_public_path__ + "static/img/18.5e527e50.jpg";